import { render, staticRenderFns } from "./edit_historial.vue?vue&type=template&id=2c6b5b28&scoped=true"
import script from "./edit_historial.vue?vue&type=script&lang=js"
export * from "./edit_historial.vue?vue&type=script&lang=js"
import style0 from "./edit_historial.vue?vue&type=style&index=0&id=2c6b5b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b5b28",
  null
  
)

export default component.exports